<template>
  <v-app app :id="!$vuetify.breakpoint.xsOnly?'bg-login':''">
    <v-row no-gutters justify="center" :align="$vuetify.breakpoint.xsOnly?null:'center'">
      <v-col cols="12" xs="12" sm="7" md="8" :class="$vuetify.breakpoint.xsOnly?'pa-0':'py-1'">
        <v-card
          tile
          :class="$vuetify.breakpoint.xsOnly?'elevation-0 animate__animated animate__fadeIn':'elevation-4 animate__animated animate__fadeIn'"
        >
          <v-row
            no-gutters
            class="animated fadeIn delay-1s"
            :justify="!$vuetify.breakpoint.xsOnly&&!$vuetify.breakpoint.smOnly?null:'center'"
            :align="!$vuetify.breakpoint.xsOnly&&!$vuetify.breakpoint.smOnly?null:'center'"
          >
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="!$vuetify.breakpoint.xsOnly&&!$vuetify.breakpoint.smOnly"
              class="login_main_bg"
            ></v-col>
            <v-col
              cols="12"
              sm="12"
              :class="$vuetify.breakpoint.xsOnly?'py-0 px-0 mt-0':'py-0'"
              v-if="$vuetify.breakpoint.smOnly||$vuetify.breakpoint.xsOnly"
            >
              <div class="login_main_bg_tablet_mobile"></div>
            </v-col>
            <v-col cols="12" xs="12" sm="10" md="6" style="padding:12% 5%">
              <v-row justify="center" align="center">
                <v-col
                  cols="11"
                  sm="12"
                  md="12"
                  :class="$vuetify.breakpoint.xsOnly?'px-0':!$vuetify.breakpoint.xsOnly&&!$vuetify.breakpoint.smOnly?'':''"
                >
                  <h2 class="font-kanit-bold">ลืมรหัสผ่าน</h2>
                  <v-card :class="mobile?'':' px-4 mt-6'">
                    <!-- <v-container> -->
                    <v-card-text>
                      <p
                        class="font-kanit-light forget-p"
                      >กรุณากรอก อีเมล และ เบอร์โทรศัพท์ ที่ท่านได้ลงทะเบียนไว้กับระบบ</p>
                      <v-form ref="forgetpasswordform" @submit.prevent="forgetPassword()">
                        <v-row class="py-0" justify="center">
                          <v-col cols="12" class="py-0 change_password_text_label">
                            <v-text-field
                              v-model="email"
                              :rules="rule_email"
                              label="อีเมล"
                              prepend-inner-icon="mdi-email-outline"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="py-0 change_password_text_label">
                            <v-text-field
                              v-model="tel_number"
                              v-mask="mobile_mask"
                              :rules="rule_tel"
                              label="เบอร์โทรศัพท์"
                              prepend-inner-icon="mdi-phone"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-btn
                              :loading="btn_loading"
                              type="submit"
                              class="font-kanit-light float-right"
                              dark
                              color="fourth"
                            >ขอรหัสผ่าน</v-btn>
                            <a
                              class="float-right pt-2 font-kanit-light mr-4"
                              color="primary"
                              style="text-decoration: underline;font-size: 16px;"
                              @click="$router.push('/')"
                            >ย้อนกลับ</a>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <!-- </v-container> -->
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>
<script>
import { mask } from "vue-the-mask";
import { rules } from "../assets/js/validate";
export default {
  directives: {
    mask,
  },
  data() {
    return {
      // mask
      mobile_mask: "###-###-####",
      btn_loading: false,
      show1: false,
      email: "",
      tel_number: "",
      rule_email: rules.email_rules,
      rule_tel: rules.tel_rules,
    };
  },
  computed: {
    mobile() {
      if (this.$vuetify.breakpoint.width < 375) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 375 ||
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (
        this.$vuetify.breakpoint.width >= 768 ||
        this.$vuetify.breakpoint.width <= 1920
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    forgetPassword() {
      if (this.$refs.forgetpasswordform.validate()) {
        this.btn_loading = true;
        let data_get_token = {
          client_id: "FW01",
          secret_key: "hv3ohTXsTzoa9tG",
        };
        var header_token = {
          headers: {
            token: "siamchai-token-dev",
          },
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/auth_service",
            data_get_token,
            header_token
          )
          .then((response) => {
            if (
              response.data.status == "OK" &&
              response.data.result.token_key != "not success"
            ) {
              let data = {
                email: this.email,
                phone: this.tel_number,
              };
              let header_token_post = {
                headers: {
                  token: response.data.result.token_key,
                },
              };
              this.axios
                .post(
                  process.env.VUE_APP_API + "/api/v1/reset_password",
                  data,
                  header_token_post
                )
                .then((response) => {
                  if (
                    response.data.status == "OK" &&
                    response.data.status != "FAIL"
                  ) {
                    this.$swal.fire({
                      icon: "success",
                      width: 500,
                      title: response.data.message,
                      text:
                        "ดำเนินการส่งรหัสผ่านใหม่ไปยังอีเมลของท่านเรียบร้อยแล้ว",
                      showConfirmButton: false,
                      timer: 2000,
                      showCloseButton: true,
                    });
                    this.btn_loading = false;
                    this.$router.push("/");
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      width: 500,
                      title: response.data.message,
                      text: "กรุณาตรวจสอบข้อมูลของท่าน",
                      showConfirmButton: false,
                      timer: 2000,
                      showCloseButton: true,
                    });

                    setTimeout(() => {
                      this.$refs.forgetpasswordform.resetValidation();
                      this.email = "";
                      this.tel_number = "";
                      this.btn_loading = false;
                    }, 500);
                    // setTimeout(() => {
                    //   window.location.reload();
                    // }, 1000);
                  }
                })
                .catch((err) => {
                  this.$swal.fire({
                    icon: "error",
                    width: 500,
                    title: "เกิดข้อผิดพลาด",
                    showConfirmButton: false,
                    timer: 2000,
                    showCloseButton: true,
                  });
                });
            }
          });
      }
    },
  },
};
</script>